<template>
  <v-app style="background-color: white">
    <v-card class="pa-3" elevation="0">
      <div>
        <v-layout wrap row text-xs-center>
          <v-flex xs12>
            <img :src="require('../assets/icon-thai-qr-cross-v1.png')" />
            <img :src="require('../assets/credit-qr-1.png')" />
          </v-flex>
        </v-layout>

        <v-flex pb-3 :class="{ 'px-3 ': $vuetify.breakpoint.smAndUp }">
          <v-divider></v-divider>
        </v-flex>
      </div>

      <div>
        <v-layout wrap row text-xs-center>
          <v-flex xs4></v-flex>
          <v-flex xs4>
            <v-flex pt-4 mb-5 text-xs-center>
              <div
                class="text-center"
                style="padding: 0 15%; padding-bottom: 25px"
              >
                <v-img
                  id="download-qr"
                  :src="qrcode"
                  style="background-color: white"
                />
              </div>
              <div class="text-xs-center" style="display: inline-block">
                <div class="display-2">
                  <label class="titillium-r">ยอดชำระรวม</label>
                  <p class="titillium-sb">{{ outstanding }} THB</p>
                </div>
              </div>
            </v-flex>
          </v-flex>
          <v-flex xs4></v-flex>
        </v-layout>
      </div>

      <!-- <v-flex>
        <v-icon medium color="red">info</v-icon>
        <span class="body-1" style="color: red">
          &nbsp;กรุณาชำระเงินให้ครบภายใน วันที่ {{ expired }}
        </span>
      </v-flex> -->
    </v-card>
  </v-app>
</template>

<script>
import * as moment from 'moment'
export default {
  created() {
    /* this.$store.state.systemScreen = 'KioskQR'
    sessionStorage.setItem('system', 'KioskQR')

    this.$watch(
      () => this.$store.state.expire,
      (newVal, oldVal) => {
        const exp = moment(this.$store.state.expire).toDate()
        if (exp.getTime() <= new Date().getTime()) {

          this.$router.push(`/paymentExpired/?linkcode=${this.$route.query.linkcode}`)

        }
         else if (
            this.$store.state.billData.status > 4 &&
            this.$store.state.billData.total == this.$store.state.billData.paid
          ) {
            this.$router.push(`/billRecieve/?linkcode=${this.$route.query.linkcode}`)
          }
          else{
            this.genQr()
          }

      } 
    ) */
  },

  async mounted() {
    this.$store.state.systemScreen = 'KioskQR'
    sessionStorage.setItem('system', 'KioskQR')

    const linkcode = this.$route.query.linkcode

    if (!linkcode) {
      return this.$router.replace('/paymentFail')
    }

    await Promise.all([
      this.$store.dispatch('getBillDataValidated', linkcode),
      this.$store.dispatch('getBillBank', linkcode)
    ])

    // check expire
    const exp = moment(this.$store.state.expire).toDate()
    if (!exp || exp.getTime() <= new Date().getTime()) {
      return this.$router.replace(`/paymentExpired/?linkcode=${linkcode}`)
    }

    // ✅ check paid (optional)
    const bill = this.$store.state.billData
    if (bill.status > 4 && bill.total == bill.paid) {
      return this.$router.replace(`/billRecieve/?linkcode=${linkcode}`)
    }

    await this.genQr()

    
  },
  methods: {
    twoDecimal(val) {
      return parseFloat(val).toFixed(2)
    },

    async genQr() {
      //console.log('genQr called')

  //console.log('billBank:', this.$store.state.billBank)

      if (!this.$store.state.billBank) {
        //console.log(' no billBank')
        return
      }
      const bank = this.$store.state.billBank.find(
        (item) => item.paymentType === 'PPCS'
      )

      //console.log('bank:', bank)
      if (!bank) {
        //console.log(' no bank PPCS')
        return
      }
      //console.log(' calling getQR')
      const qr = {
        method: 'PPCS',
        refcode: this.$store.state.linkcode,
        amount: this.$store.state.amount,
        bubankid: bank.id,
        bank: bank.Bank
      }

      await this.$store.dispatch('getQR', qr)
    }

    /* genQr() {
      this.NotGenQR = 0
      this.timeInterval = 30000


          //console.log('watch outstanding ' + this.$store.state.outstanding)
          if (this.$store.state.outstanding === 0) {
            this.NotGenQR = 1
            this.timeInterval = 1000
            //console.log('watch NotGenQR ' + this.NotGenQR)
          }

          //console.log('Interval ' + this.timeInterval)
          let billStatus = setInterval(() => {
            if (this.$route.name == 'kioskqr') {
              //console.log('setInterval')
              this.$store
                .dispatch('getBillDataStatus', this.$route.query.linkcode)
                .then(() => {
                  if (this.$store.state.billDataStatus != 2) {
                    let page =
                      this.$store.state.billDataStatus <= 3
                        ? 'kioskqr'
                        : // : 'billRecieve'
                          'billRecieve'
                    clearInterval(billStatus)
                    this.$router.push(
                      `/${page}/?linkcode=${this.$route.query.linkcode}`
                    )
                  }
                })
            }
          }, this.timeInterval)

          //console.log('check NotGenQR ' + this.NotGenQR)
          if (this.NotGenQR == 0) {
            //console.log('GenQR zz')
            //console.log('watch billBank ' + this.$store.state.billBank)

            if (this.$store.state.billBank) {
              //console.log('billbank zz')
              var bank = this.$store.state.billBank.filter((item) => {
                return item.paymentType == 'PPCS'
              })
              let qr = {}
              this.method = 'PPCS'
              qr.method = 'PPCS'
              qr.refcode = this.$store.state.linkcode
              qr.amount = this.$store.state.amount
              qr.bubankid = bank[0].id
              qr.updateQr = this.$store.state.qr
              qr.bank = bank[0].Bank
              this.$store.dispatch('getQR', qr)
            }
          }
        
      // console.log("Interval " + this.timeInterval)
      // let billStatus = setInterval(() => {
      //   if (this.$route.name == 'kioskqr') {
      //     console.log("setInterval")
      //     this.$store
      //       .dispatch('getBillDataStatus', this.$route.query.linkcode)
      //       .then(() => {
      //         if (this.$store.state.billDataStatus != 2) {
      //           let page =
      //             this.$store.state.billDataStatus <= 3
      //               ? 'kioskqr'
      //               : // : 'billRecieve'
      //                 'paymentSuccess'
      //           clearInterval(billStatus)
      //           this.$router.push(
      //             `/${page}/?linkcode=${this.$route.query.linkcode}`
      //           )
      //         }
      //       })
      //   }
      // }, this.timeInterval)

      // this.$watch(
      //       () => this.$store.state.billBank,
      //       (newVal, oldVal) => {
      //         console.log("watch 2" +this.$store.state.billBank)

      //         if (this.$store.state.billBank) {
      //         console.log('billbank zz')
      //         var bank = this.$store.state.billBank.filter((item) => {
      //           return item.paymentType == 'PPCS'
      //         })
      //         let qr = {}
      //         this.method = 'PPCS'
      //         qr.method = 'PPCS'
      //         qr.refcode = this.$store.state.linkcode
      //         qr.amount = this.$store.state.amount
      //         qr.bubankid = bank[0].id
      //         qr.updateQr = this.$store.state.qr
      //         this.$store.dispatch('getQR', qr)
      //         }

      //       }
      //   )
    }, */
  },
  computed: {
    qrcode() {
      if (!this.$store.state.qr) return require('@/assets/no_img.png')
      return this.$store.state.qr
    },
    outstanding() {
      return this.twoDecimal(this.$store.state.outstanding)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    expired() {
      if (this.$store.state.language == 'EN') {
        return this.$store.state.expireDateTimeEn
      } else {
        return this.$store.state.expireDateTimeTh
      }
    },
    // route() {
    //   console.log("route")
    //   let page = '/'
    //   if (this.$store.state.ref2) {
    //     page = '/authen'
    //   } else {
    //     sessionStorage.setItem('linkcode', this.$route.query.linkcode)
    //     if (
    //       this.$store.state.billData.status &&
    //       this.$store.state.billData.status > 3 &&
    //       this.$store.state.billData.total == this.$store.state.billData.paid
    //     ) {
    //       page = '/billRecieve'
    //     } else {
    //       page = '/paymentMethods'
    //     }
    //   }
    //   return page + `/?linkcode=${this.$route.query.linkcode}`
    // },
  },
}
</script>
